module.exports = __webpack_public_path__ + "itv-logo-2e203bea689662ed219751ad76d1e200.png";